var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCircleCheckFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm4.372-12.51a1 1 0 0 0-1.744-.98l-3.853 6.85-2.568-2.567a1 1 0 0 0-1.414 1.414l3.034 3.034a1.5 1.5 0 0 0 2.368-.325l4.177-7.426Z",
  clipRule: "evenodd"
})));
export default SvgIconCircleCheckFilled;